import { render, staticRenderFns } from "./MemberStatistic.vue?vue&type=template&id=08d4b2bc&scoped=true&"
import script from "./MemberStatistic.vue?vue&type=script&lang=js&"
export * from "./MemberStatistic.vue?vue&type=script&lang=js&"
import style0 from "./MemberStatistic.vue?vue&type=style&index=0&id=08d4b2bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4b2bc",
  null
  
)

export default component.exports